import ajax from '../ajax';

const ROLE_ADMIN = 1;
const ROLE_CLINIC = 2;
const ROLE_PATIENT = 3;

async function fetchUsers(params) {
    const response = await ajax.get('admin/users', { params });
    return response.data;
}

export { ROLE_ADMIN, ROLE_CLINIC, ROLE_PATIENT, fetchUsers };
